module.exports = __webpack_public_path__ + "ico_comsum_report.png";